export default Object.freeze([
  'Childhood',
  'Coming-Of-Age',
  'Community',
  'Crime',
  'Death',
  'Environment',
  'Friendship',
  'Health',
  'Hope',
  'Identity',
  'Inspiration',
  'Loss',
  'Mental Health',
  'Politics',
  'Relationship',
  'Sexuality',
]);



// WEBPACK FOOTER //
// ./src/assets/data/viddsee/topics.js